import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { css } from '@emotion/react';
import { NoChatListMessage } from '~/components/common/NoItemMessage';
import { ChatRoomListSkeleton } from '~/components/common/Skeleton';
import { useGetChatRoomListQuery } from '~/features/chatRoom';
import { useIntersectionObserver } from '~/hooks';
import { ChatAllRoomType } from '~/types';
import { PAGE_ROUTE } from '~/constants';
import useChatPageLoadingStatus from '~/store/useChatPageLoadingStatusStore';
import ChatRoomListItem from './ChatRoomListItem';

export default function ChatRoomList() {
  const navigate = useNavigate();

  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });
  const {
    data: chatRoomListData,
    fetchNextPage,
    isFetchingNextPage,
  } = useGetChatRoomListQuery();
  const { setChatPageLoadingStart, isChatPageLoading } =
    useChatPageLoadingStatus();

  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage();
    }
  }, [isIntersecting]);

  const handleChangeUrl = (
    type: ChatAllRoomType,
    chatroom_id: string,
    characterImg: string,
  ) => {
    // 채팅방으로 이동, 채팅방 진입 로딩 레이아웃 Start
    setChatPageLoadingStart(characterImg);

    if (type === 'group') {
      navigate(`${PAGE_ROUTE.GROUP_CHAT}/${chatroom_id}`);
    } else if (type === 'mystery') {
      navigate(`${PAGE_ROUTE.MYSTERY}/${chatroom_id}`);
    } else if (type === 'concept') {
      navigate(`${PAGE_ROUTE.CHAT_CONCEPT}/${chatroom_id}`);
    } else {
      navigate(`${PAGE_ROUTE.CHAT}/${chatroom_id}`);
    }
  };

  const [openMenuId, setOpenMenuId] = useState<string>('');

  useEffect(() => {
    setOpenMenuId('');
  }, []);

  if (chatRoomListData.pages.length === 0) {
    return <NoChatListMessage />;
  }

  return (
    <ul
      css={css`
        display: flex;
        flex-direction: column;
        overflow: hidden;
      `}
    >
      {/* {chatRoomListData.pages.map( */}
      {chatRoomListData.pages.map(
        ({
          title,
          chatroom_uuid,
          latest_chat,
          latest_chat_time,
          type,
          is_owner,
          ai_thumbnails,
          total_member,
          notification_on,
        }) => (
          <ChatRoomListItem
            key={chatroom_uuid}
            id={chatroom_uuid}
            title={title}
            characters={ai_thumbnails}
            handleChangeUrl={() =>
              handleChangeUrl(type, chatroom_uuid, ai_thumbnails[0])
            }
            chat={latest_chat}
            time={latest_chat_time}
            type={type}
            isOwner={is_owner}
            totalMember={total_member}
            notificationOn={notification_on}
            isOpenMenu={openMenuId === chatroom_uuid}
            setOpenMenuId={setOpenMenuId}
          />
        ),
      )}
      {isFetchingNextPage ? <ChatRoomListSkeleton /> : <div ref={ref} />}
    </ul>
  );
}
